import * as zod from 'zod';

export const StitchingConfig = zod.object({
  enabled: zod.boolean().default(false),
  stitch: zod.number().gt(0), // Stitch size in meters
  space: zod.number().gt(0), // Space between stitches in meters
  spaceSpeedMultiplier: zod.number().gt(0).default(3), // Multiplier of weld travel speed for space segments
});

export type StitchingConfig = zod.infer<typeof StitchingConfig>;

export type StitchingConfigWithSpaceTravelParameters = StitchingConfig & {
  spaceTravelSpeed: number;
  spaceTravelAcceleration: number;
};
